/**
 * Класс Tools - вспомогательные функции
 */
class Tools {
    constructor() {
        this.timers = {};
    }

    deviceIsMobile()
    {
        return window.innerWidth < 768;
    }

    /**
     * Запустить таймер
     * @param key
     * @param callback
     * @param delay
     */
    runTimer(key, callback, delay = 500)
    {
        if (typeof this.timers[key] !== 'undefined') {
            clearTimeout(this.timers[key]);
        }

        this.timers[key] = setTimeout(callback, delay);
    }

    /**
     * CSRF токен
     * @return {*|jQuery|undefined}
     */
    getCSRFToken()
    {
        return $('meta[name="csrf-token"]').attr('content');
    }

    /**
     * Клонирование объекта
     * @param obj
     * @return {any}
     */
    clone(obj)
    {
        return JSON.parse(JSON.stringify(obj));
    }

    /**
     * превыращение строки в хеш
     * @param string
     * @return {number}
     */
    getStringHash(string) {
        let hash = 0;

        if (string.length === 0) return hash;

        for (let i = 0; i < string.length; i++) {
            let char = string.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash;
        }

        return hash;
    }

    /**
     * Хеш объекта
     * @param obj
     * @return {number}
     */
    getObjectHash(obj)
    {
        return this.getStringHash(JSON.stringify(obj));
    }

    /**
     * Добавляет/удаляет элемент массива в зависимости от наличия этого элемента в массиве
     * @param arr - массив
     * @param el - элемент
     * @returns {*[]}
     */
    toggleArrayElement(arr, el) {
        let arrCopy = arr;
        let index = arrCopy.indexOf(el);
        if (index !== -1) {
            arrCopy.splice(index, 1);
        } else {
            arrCopy.push(el);
        }
        return arrCopy;
    }

    /**
     * Получить ID видео из ссылки на YouTube
     * @param url
     * @returns {string|null}
     */
    getYouTubeVideoId(url) {
        let videoId = null;
        let youtubeMatchExp = '((?:https?:)?\\/\\/)?((?:www|m)\\.)?((?:youtube\\.com|youtu.be))(\\/(?:[\\w\\-]+\\?v=|embed\\/|v\\/)?)([\\w\\-]+)(\\S+)?';
        let youtubeMatch = url.match(youtubeMatchExp);

        if (youtubeMatch) {
            if (typeof youtubeMatch[5] !== 'undefined') {
                videoId = youtubeMatch[5];
            }
        }

        return videoId;
    }

    /**
     * Возвращает форму слова в зависимости от связанного со словом числа
     * @param {number} count
     * @param {string[]} forms
     * @returns {string}
     */
    pluralize(count, forms) {
        let result = '';
        if (count === 1) {
            result = forms[0];
        } else if (count < 5) {
            result = forms[1];
        } else {
            result = forms[2];
        }
        return result;
    }

    /**
     * Сохранение локальных данных
     * @param key
     * @param data
     */
    setLocalData(key, data) {
        if (!localStorage) {
            return;
        }
        localStorage.setItem(key, data);
    }

    /**
     * Получение локальных данных
     * @param key
     * @returns {string|null}
     */
    getLocalData(key)
    {
        if (!localStorage) {
            return;
        }
        return localStorage.getItem(key);
    }

    /**
     * Фокус находится на поле инпута или текстарии
     * @returns {boolean}
     */
    userFocusedOnInput()
    {
        const $focused = $(':focus');
        if (!$focused.length) {
            return false;
        }

        const focusedTagName = $focused.prop('tagName').toLowerCase();

        return focusedTagName === 'input' || focusedTagName === 'textarea';
    }
}

export default new Tools();
